import React from "react";
import { Form, Row, Col } from "react-bootstrap";

import "./Forms.css";
import InputError from "../../InputError/InputError";

function TextField({
  required = false,
  type,
  formLabel,
  size,
  placeholder,
  name,
  value,
  onChange,
  onBlur,
  isError,
  disabled,
  errorMessage = "",
  onKeyDown,
  maxLength,
}) {
  return (
    <Form>
      {type === "inline" ? (
        <Form.Group className="mb-3" controlId="formBasicEmail">
          <Row>
            <Col sm={4}>
              <Form.Label className="form-label align-left">
                {formLabel}
                {required && <span className="badge">*</span>}
              </Form.Label>
            </Col>
            <Col sm={6}>
              <Form.Control
                type="text"
                placeholder={placeholder}
                size={size}
                name={name}
                value={value}
                defaultValue={value}
                onChange={onChange}
                onBlur={onBlur}
                disabled={disabled}
                // onKeyDown={onKeyDown}
                maxLength={maxLength}
                onKeyDown={(e) => {
                  if (e.key === "Enter") e.preventDefault();
                  if (onKeyDown) onKeyDown(e);
                }}
              />
              <InputError
                isValid={isError}
                message={
                  errorMessage !== "" ? errorMessage : "This field is required"
                }
              />
            </Col>
          </Row>
        </Form.Group>
      ) : (
        <>
          <Form.Group className="mb-3" controlId="formBasicEmail">
            <Form.Label className="align-left form-label">
              {formLabel}
              {required && <span className="badge">*</span>}
            </Form.Label>
            <Form.Control
              type="text"
              placeholder={placeholder}
              size={size}
              name={name}
              value={value}
              defaultValue={value}
              onChange={onChange}
              onBlur={onBlur}
              disabled={disabled}
              // onKeyDown={onKeyDown}
              maxLength={maxLength}
              onKeyDown={(e) => {
                if (e.key === "Enter") e.preventDefault();
                if (onKeyDown) onKeyDown(e);
              }}
            />
            <InputError
              isValid={isError}
              message={
                errorMessage !== "" ? errorMessage : "This field is required"
              }
            />
          </Form.Group>
        </>
      )}
    </Form>
  );
}

export default TextField;
